export const menuItems = [
  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },

  {
    id: 2,
    label: "common.library",
    icon: "mdi mdi-database",
    subItems: [
      {
        id: "audit-control-library",
        label: "audit-control.text",
        subItems: [
          {
            id: "control-type",
            label: "audit-control.control.type",
            link: "/management/library/control-type",
          },
          {
            id: "control-category",
            label: "audit-control.control.category",
            link: "/management/library/control-category",
          },
        ],
      },
      {
        id: "asset-group",
        label: "asset-group.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: 3,
            label: "asset-group-category.text",
            link: "/management/asset-group-category",
            parentId: 2.5,
          },
          {
            id: 4,
            label: "asset-group.text",
            link: "/management/asset-group",
            parentId: 2.5,
          },
        ],
      },
      {
        id: 2,
        label: "organization-hierarchy.text",
        icon: "mdi mdi-database",
        subItems: [
          {
            id: "unit",
            label: "unit.text",
            icon: "mdi mdi-office-building",
            link: "/management/unit",
          },
          {
            id: 5,
            label: "department.text",
            link: "/management/department",
            parentId: 2,
          },
          {
            id: 6,
            label: "department-category.text",
            link: "/management/department-category",
            parentId: 2,
          },
          {
            id: 6,
            label: "process.text",
            link: "/management/process",
            parentId: 2,
          },
          {
            id: 7,
            label: "process-category.text",
            link: "/management/process-category",
            parentId: 2,
          },
        ],
      },
      {
        id: "task-library",
        label: "task.plural",
        subItems: [
          {
            id: "task-category",
            label: "task-category.text",
            link: "/management/task-category",
          },
        ],
      },
      {
        id: "finding-library",
        label: "audit-finding.title",
        subItems: [
          {
            id: "finding-type",
            label: "audit-finding.type.text",
            link: "/management/library/finding-type",
          },
          // {
          //   id: "finding-sub-source",
          //   label: "audit-finding.sub-source.text",
          //   link: "/management/library/finding-sub-source",
          // },
          {
            id: "finding-root-cause",
            label: "audit-finding.root-cause.text",
            link: "/management/library/finding-root-cause",
          },
          {
            id: "finding-category",
            label: "audit-finding.category.text",
            link: "/management/library/finding-category",
          },
        ],
      },
      {
        id: "compliance-item-group",
        label: "compliance-item-group.text",
        link: "/management/compliance-item-group",
      },
      {
        id: "compliance-item",
        label: "compliance-item.text",
        link: "/management/compliance-item",
      },
      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/management/policy",
          },
          {
            id: "policy-category",
            label: "policy-category.text",
            link: "/management/policy-category",
          },
        ],
      },

      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/management/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/management/question",
          },
        ],
      },
      {
        id: "report-template",
        label: "report-template.text",
        subItems: [
          {
            id: "report-template",
            label: "report-template.text",
            link: "/management/report-template",
          },
        ],
      },
      {
        id: "risk",
        label: "risk.text",
        subItems: [
          {
            id: "risk-definition",
            label: "risk.definition.text",
            link: "/management/risk-definition",
          },
          {
            id: "risk-threat-definition",
            label: "risk.threat-definition.text",
            link: "/management/risk-threat-definition",
          },
          {
            id: "risk-source",
            label: "risk.source.text",
            link: "/management/risk-source",
          },
          {
            id: "risk-type",
            label: "risk.type.text",
            link: "/management/risk-type",
          },
          {
            id: "risk-category",
            label: "risk.category.text",
            link: "/management/risk-category",
          },
          {
            id: "risk-weakness-definition",
            label: "risk.weakness-definition.text",
            link: "/management/risk-weakness-definition",
          },
          {
            id: "risk-applied-control",
            label: "risk.applied-control.text",
            link: "/management/risk-applied-control",
          },
        ],
      },
    ],
  },

  {
    id: 6,
    isLayout: true,
  },
  {
    id: 7,
    label: "account.text",
    isTitle: true,
  },

  {
    id: "app-panel",
    label: "common.panel",
    icon: "bx-user",
    link: "/management/account-workspace-organization",
  },

  {
    id: "role-management",
    label: "role.plural",
    icon: "bx-shield-quarter",
    link: "/management/role",
  },

  {
    id: "role-access-management",
    label: "role.access.text",
    icon: "bx-shield-quarter",
    link: "/management/role-access",
  },
  {
    id: 105,
    label: "common.system",
    isTitle: true,
  },
  {
    id: "log",
    label: "log.text",
    icon: "bx-code",
    link: "/management/log",
  },
  {
    id: "mail-log",
    label: "log.mail.text",
    icon: "mdi mdi-email-check-outline",
    link: "/management/mail-log",
  },

  // {
  //   id: "announcement",
  //   label: "announcement.plural",
  //   icon: "bx bxs-megaphone",
  //   link: "/management/announcement",
  // },
  {
    id: "config",
    label: "config.text",
    icon: "bx bx-cog",
    link: "/management/config",
  },
];
